import "./fake-db";
import "./i18n/config";
import React from "react";
import { Provider, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import AppContext from "./contexts/AppContext";
import routes from "./routes/RootRoutes";
import { Store } from "./redux/Store";
import { GlobalCss, LoonsSuspense, LoonsLayout } from "components";
import { AuthRoutes as sessionRoutes } from "./pages/auth";
import PublicRoutes from "./routes/PublicRoutes";
import AuthGuard from "./auth/AuthGuard";
import { SettingsProvider } from "./contexts/SettingsContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import LoonsTheme from "components/themeFiles/LoonsTheme";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SpacingGlobalStyles from "./styles/SpacingGlobalStyles";
import { AnimatePresence } from "framer-motion";
import { ComingSoon } from "./pages/ComingSoon";
import { LAUNCH_DATE, EARLY_ACCESS_END } from "./config/launchDate";

window.dashboardVariables = {};

const AppRoutes = () => {
  const location = useLocation();
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* PUBLIC LANDING PAGE - Only show when not authenticated */}
        {!isAuthenticated && PublicRoutes.map((item, i) => (
          <Route key={i} path={item.path} element={<item.component />} />
        ))}

        {/* AUTHENTICATION PAGES (SIGNIN, SIGNUP ETC.) */}
        {sessionRoutes.map((item, i) => (
          <Route key={i} path={item.path} element={<item.component />} />
        ))}

        {/* AUTH PROTECTED DASHBOARD PAGES */}
        <Route
          path="/*"
          element={
            <AuthGuard>
              <LoonsLayout />
            </AuthGuard>
          }
        />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => {
  const now = Date.now();
  const showComingSoon =
    now >= EARLY_ACCESS_END.getTime() && now < LAUNCH_DATE.getTime();
  if (showComingSoon) {
    return <ComingSoon />;
  }

  return (
    <AppContext.Provider value={{ routes }}>
      <Provider store={Store}>
        <SettingsProvider>
          <LanguageProvider>
            <LoonsTheme>
              <SpacingGlobalStyles />
              <GlobalCss />
              <ToastContainer
                position="top-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
              <Router>
                <LoonsSuspense>
                  <AppRoutes />
                </LoonsSuspense>
              </Router>
            </LoonsTheme>
          </LanguageProvider>
        </SettingsProvider>
      </Provider>
    </AppContext.Provider>
  );
};

export default App;
